export default __webpack_public_path__ + "static/media/pasivoUtilidadesIcon.51141faa.svg";